import { DocumentType, Locale } from '@synergy/models';
import { sortByProperty } from '@synergy/utils';

import { ConverterJob } from '../models/internal/converterJob';
import { ConverterPositionItem } from '../models/internal/converter-positionItem';
import { PurchaseOrder } from '../../purchase-orders/models/purchaseOrder';
import { TransitionTarget } from '../models/internal/transition-target';

export const createConverterJobFromPurchaseOrder = (purchaseOrder: PurchaseOrder): ConverterJob => {
    const possibleTargets = [TransitionTarget.Invoice, TransitionTarget.Credit];

    const items = purchaseOrder.purchaseOrderItems.map(ConverterPositionItem.fromPlainObject);
    const surchargeItems = purchaseOrder.surchargeItems.map(surchargeItem =>
        ConverterPositionItem.fromPlainObject({
            id: surchargeItem.id,
            price: surchargeItem.price,
            tax: surchargeItem.tax,
            discount: surchargeItem.discount,
            name: { [Locale.German]: surchargeItem.title },
            quantity: surchargeItem.quantity,
            converterInfo: surchargeItem.type,
            position: surchargeItem.position,
            shortDescription: { [Locale.German]: surchargeItem.description },
        })
    );

    const allItems = sortByProperty({
        data: [...items, ...surchargeItems],
        key: 'position',
    });

    const source: ConverterJob = {
        source: purchaseOrder,
        possibleTargets,
        selectedTarget: TransitionTarget.Invoice,
        selectedCustomerId: -1,
        documentType: DocumentType.PurchaseOrder,
        supportsDeliveryCosts: true,
        hasDeliveryDate: false,
        customers: [
            {
                id: purchaseOrder.customerAccount.id,
                name: purchaseOrder.customerAccount.name,
                isLocked: purchaseOrder.customerAccount.isLocked,
                deliveryAddress: purchaseOrder.deliveryAddress,
                customerContact: purchaseOrder.customerContact,
                customerSuppliers: [
                    {
                        id: purchaseOrder.supplierAccount.id,
                        name: purchaseOrder.supplierAccount.name,
                        isLocked: purchaseOrder.supplierAccount.isLocked,
                        deliveryPrice: purchaseOrder.netShippingCosts,
                        items: allItems,
                        surcharge: purchaseOrder.netSurcharge,
                        address: purchaseOrder.supplierAccount.mainAddress,
                        deliveryDate: purchaseOrder.deliveryDate,
                    },
                ],
            },
        ],
    };
    return ConverterJob.fromPlainObject(source);
};
